/**
 * The static shape-handler strategies. A mode that needs per-shape handlers
 * builds a full strategy with `createFullShapeStrategy` instead.
 */
export const ShapeStrategy = {
	/** Disable all shape interactions (click-through). */
	disabled: { strategy: 'disabled' },
	/** Hover-only, for cursor detection. */
	hoverOnly: { strategy: 'hoverOnly' },
} as const;
